// Built-in backgrounds (public assets). Custom user uploads come from the API.

export const builtInBackgrounds = {
  'branded-light': {
    id: 'branded-light',
    name: 'Branded Light Blue',
    url: '/zoom-background-2.png',
    description: 'Lighter blue with logo top-left',
    builtin: true,
  },
  'branded-deep': {
    id: 'branded-deep',
    name: 'Branded Deep Navy',
    url: '/zoom-background.png',
    description: 'Deep navy with logo top-left',
    builtin: true,
  },
};

export const defaultBackground = 'branded-light';

// Legacy export
export const backgrounds = builtInBackgrounds;
